import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { persist, devtools } from 'zustand/middleware'
import {
  PANEL_STATES,
  BUDGETING_PERIODS,
  NON_MODAL_WINDOW_STATE,
  MODAL_WINDOW_STATE,
  ARCHIVE_STEP,
} from '@/data/constants/constants'

let store = immer((set) => ({
  offset: 1,
  numberOfPeriods: 13,
  periodType: BUDGETING_PERIODS.WEEK,
  count: 0,
  panelState: PANEL_STATES.CLOSED,
  modalWindowState: MODAL_WINDOW_STATE.CLOSED,
  nonModalWindowState: NON_MODAL_WINDOW_STATE.CLOSED,
  modalWindowType: null,
  nonModalWindowType: null,
  transactionCategoryId: null,
  addOrEditiTransaction: null,
  modalProps: {},
  nonModalName: null,
  nonModalProps: {},
  archiveStep: ARCHIVE_STEP.FIRST,
  archivedVault: undefined,
  archivedEntity: null,
  selectedMyTodoTransactionRowId: null,
  dockTransactionListView: false,
  cellTransactionsLoaded: false,
  setCellTransactionsLoaded: (value) =>
    set((state) => {
      state.cellTransactionsLoaded = value
    }),
  setDockTransactionListView: (value) =>
    set((state) => {
      state.dockTransactionListView = value
    }),
  setSelectedMyTodoTransactionRowId: (value) =>
    set((state) => {
      state.selectedMyTodoTransactionRowId = value
    }),
  setArchiveStep: (value) =>
    set((state) => {
      state.archiveStep = value
    }),
  setNonModalProps: (value) =>
    set((state) => {
      state.nonModalProps = value
    }),
  setModalProps: (value) =>
    set((state) => {
      state.modalProps = value
    }),
  setNonModalName: (value) =>
    set((state) => {
      state.nonModalName = value
    }),
  setPanelState: (value) =>
    set((state) => {
      state.panelState = value
    }),
  setEditedEntity: (value) =>
    set((state) => {
      state.editedEntity = value
    }),
  setArchivedEntity: (value) =>
    set((state) => {
      state.archivedEntity = value
    }),
  setArchivedVault: (value) =>
    set((state) => {
      state.archivedVault = value
    }),
  togglePanelState: () =>
    set((state) => {
      state.panelState =
        state.panelState === PANEL_STATES.CLOSED
          ? PANEL_STATES.OPENED
          : PANEL_STATES.CLOSED
    }),
  setNonModalWindowState: (value) =>
    set((state) => {
      state.nonModalWindowState = value
    }),
  toggleNonModalWindowState: () =>
    set((state) => {
      state.nonModalWindowState =
        state.nonModalWindowState === NON_MODAL_WINDOW_STATE.CLOSED
          ? NON_MODAL_WINDOW_STATE.OPENED
          : NON_MODAL_WINDOW_STATE.CLOSED
    }),
  setNonModalWindowType: (value) =>
    set((state) => {
      state.nonModalWindowType = value
    }),
  toggleModalWindowState: () =>
    set((state) => {
      state.modalWindowState =
        state.modalWindowState === PANEL_STATES.CLOSED
          ? PANEL_STATES.OPENED
          : PANEL_STATES.CLOSED
    }),
  toggleArchiveStep: () =>
    set((state) => {
      state.archiveStep =
        state.archiveStep === ARCHIVE_STEP.FIRST
          ? ARCHIVE_STEP.SECOND
          : ARCHIVE_STEP.FIRST
    }),
  setModalWindowState: (value) =>
    set((state) => {
      state.modalWindowState = value
    }),
  setModalWindowType: (value) =>
    set((state) => {
      state.modalWindowType = value
    }),

  setOffset: (value) =>
    set((state) => {
      state.offset = value
    }),
  setNumberOfPeriods: (value) =>
    set((state) => {
      state.numberOfPeriods = value
      state.offset = 1
    }),
  setPeriodType: (value) =>
    set((state) => {
      state.periodType = value
    }),
  reset: () =>
    set({
      archivedEntity: null,
      modalWindowType: null,
      archivedVault: null,
    }),
  // increment: (qty) =>
  //   set((state) => {
  //     state.count += qty
  //   }),
  // decrement: (qty) =>
  //   set((state) => {
  //     state.count -= qty
  //   }),
}))

store = devtools(store)
store = persist(store, {
  name: 'app-store',
  getStorage: () => sessionStorage,
  partialize: (state) => ({
    ...state,
    selectedMyTodoTransactionRowId: undefined,
    offset: undefined,
    nonModalWindowState: undefined,
    setNonModalProps: undefined,
    modalProps: undefined,
    archivedVault: undefined,
    modalWindowType: undefined,
    editedEntity: undefined,
    cellTransactionsLoaded: undefined,
    dockTransactionListView: undefined,
  }),
})

const useAppStore = create(store)

export default useAppStore
